import { render } from "./SyndicatedStoryEditor.vue.js?vue&type=template&id=31a3a270!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SyndicatedStoryEditor.vue?vue&type=template&id=31a3a270"
import script from "./SyndicatedStoryEditor.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SyndicatedStoryEditor.vue?vue&type=script&lang=js"
export * from "./SyndicatedStoryEditor.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SyndicatedStoryEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/stories/SyndicatedStoryEditor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "31a3a270"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('31a3a270', __exports__)) {
    api.reload('31a3a270', __exports__)
  }
  
  module.hot.accept("./SyndicatedStoryEditor.vue.js?vue&type=template&id=31a3a270!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SyndicatedStoryEditor.vue?vue&type=template&id=31a3a270", () => {
    api.rerender('31a3a270', render)
  })

}


export default __exports__